<div class="bary-datepicker md-form md-outline">
  <jhi-bary-input-text
    [id]="id"
    [control]="textControl"
    [placeholder]="placeholder"
    [label]="label"
    [disabled]="disabled"
    icon="calendar"
    (click)="openCalendar()"
  ></jhi-bary-input-text>
  <mdb-error *ngIf="control && control.invalid && (control.dirty || control.touched)">
    <span *ngIf="control.hasError('required')" jhiTranslate="ERROR.REQUIRED_FIELD"></span>
  </mdb-error>
  <div class="bary-datepicker-calendar">
    <mdb-date-picker #datePicker [options]="myDatePickerOptions" [placeholder]="label" [locale]="'fr'" [formControl]="datePickerControl"></mdb-date-picker>
  </div>
</div>
